import type { ReactNode } from 'react';
import { Logo } from '../components/ui';
import { config } from '../config';
import './AuthLayout.css';

/** Two panels: a calm brand side and the form. Below 860px, the form alone, top-aligned under the logo. */
export function AuthLayout({
  title,
  subtitle,
  children,
  personal = false,
}: {
  title: string;
  subtitle?: string;
  children: ReactNode;
  /** Someone using EducAitor on their own: the brand side speaks to them, not to leaders. */
  personal?: boolean;
}) {
  const eyebrow = personal ? 'For your teaching' : 'For leadership';
  return (
    <div className="auth">
      <aside className="auth-brand" aria-hidden="true">
        <div className="auth-brand-inner">
          <p className="auth-brand-eyebrow">{eyebrow}</p>
          <p className="auth-brand-line">
            {personal ? 'Private, practical feedback on every lesson you teach, and a clear view of how you’re growing.' : 'See how your team is developing, and where support will help most.'}
          </p>
          <p className="auth-brand-foot">Development, not judgement.</p>
        </div>
        <div className="auth-rings">
          <span />
          <span />
          <span />
        </div>
      </aside>
      <main className="auth-main" id="main">
        <div className="auth-card">
          <div className="auth-top">
            <Logo height={30} />
            {/* Phones and tablets: the brand panel is hidden, so a quiet line of it stays with the logo. */}
            <span className="auth-eyebrow">{eyebrow}</span>
          </div>
          <div className="auth-heading">
            <h1>{title}</h1>
            {subtitle ? <p className="muted">{subtitle}</p> : null}
          </div>
          {children}
          <footer className="auth-legal">
            <nav aria-label="Legal and help">
              <a href="https://educaitor.ai/privacy-policy/" target="_blank" rel="noreferrer">
                Privacy
              </a>
              <a href="https://educaitor.ai/terms/" target="_blank" rel="noreferrer">
                Terms
              </a>
              <a href="mailto:support@educaitor.ai">Support</a>
              {config.appStoreUrl ? (
                <a href={config.appStoreUrl} target="_blank" rel="noreferrer">
                  App Store
                </a>
              ) : null}
              {config.playStoreUrl ? (
                <a href={config.playStoreUrl} target="_blank" rel="noreferrer">
                  Google Play
                </a>
              ) : null}
            </nav>
          </footer>
        </div>
      </main>
    </div>
  );
}
